"use client";

import Image from "next/image";
import { Check } from "lucide-react";
import { useId, useState, type CSSProperties } from "react";

import { CcSanjayaEyebrow } from "@/components/ui/CcSanjayaEyebrow";

import type { AxChecksCopy } from "./annonsrontgen-copy";

/** "Vad vi tittar på": one tab per ad channel with what the X-ray covers there. */
export function CcAxChecks({ copy }: { copy: AxChecksCopy }) {
  const [active, setActive] = useState(0);
  const id = useId();
  const tab = copy.tabs[active];

  return (
    <section data-cc-nav="light"
      className="cc-ax-section cc-ax-checks"
      aria-labelledby={`${id}-title`}
    >
      <div className="cc-ax-shell">
        <header className="cc-ax-head">
          <CcSanjayaEyebrow as="p" theme="on-subtle">
            {copy.eyebrow}
          </CcSanjayaEyebrow>
          <h2 id={`${id}-title`} className="cc-seo-heading">
            {copy.title}
          </h2>
        </header>
        <div
          className="cc-ax-checks__tabs"
          role="tablist"
          aria-label={copy.title}
        >
          {copy.tabs.map((item, index) => (
            <button
              key={item.id}
              type="button"
              role="tab"
              id={`${id}-tab-${item.id}`}
              aria-selected={index === active}
              aria-controls={`${id}-panel`}
              onClick={() => setActive(index)}
            >
              <Image
                src={item.logo}
                alt=""
                width={18}
                height={18}
                unoptimized
              />
              {item.name}
            </button>
          ))}
        </div>
        <div
          key={tab.id}
          id={`${id}-panel`}
          role="tabpanel"
          aria-labelledby={`${id}-tab-${tab.id}`}
        >
          <ul className="cc-ax-checks__list">
          {tab.items.map((item, index) => (
            <li key={item} style={{ "--i": index } as CSSProperties}>
              <Check size={16} strokeWidth={2.6} aria-hidden="true" />
              {item}
            </li>
          ))}
          </ul>
        </div>
      </div>
    </section>
  );
}
